import React from "react";
import locale from "@bonliva-crm/locale";
import { useGetFreshdeskTicketsCountQuery } from "@bonliva-crm/graphql";
import { Spinner } from "@common";

type Props = {
  consultantId: string;
};

export const FreshdeskTicketsTabLabel: React.FC<Props> = ({ consultantId }) => {
  // Fetches the open-ticket count in the background on profile open — non-blocking,
  // so it never delays opening a consultant profile.
  const { data } = useGetFreshdeskTicketsCountQuery({
    variables: { consultantId },
    fetchPolicy: "cache-and-network",
    onError: () => undefined // never break the tab bar on a Freshdesk hiccup
  });

  // Apollo keys `data` to the CURRENT variables, so when switching between
  // consultants it is undefined until the new count resolves — we show a spinner
  // rather than the previous consultant's (stale) number.
  const count = data?.freshdeskOpenTicketsCountByConsultant;

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
      {locale.freshdeskTickets.title}
      {count === undefined ? <Spinner size={12} inline /> : ` (${count})`}
    </span>
  );
};

export default FreshdeskTicketsTabLabel;
